import { originalServicePages } from './servicePagesOriginal'
import { newServicePages } from './servicePagesNew'

export const servicePages = [...originalServicePages, ...newServicePages]
